"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _AVNURAH2cjs = require('../__chunks/AVNURAH2.cjs');


var _EXYNE2GEcjs = require('../__chunks/EXYNE2GE.cjs');
require('../__chunks/FAZMJLCO.cjs');
require('../__chunks/XDATOVDX.cjs');
require('../__chunks/JLMLKTUB.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/UCZW3OGH.cjs');
require('../__chunks/XWMMMXUK.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');



var _3BSDKDKDcjs = require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/select/select-heading.tsx
var _react = require('react');
var TagName = "h1";
var useSelectHeading = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useSelectHeading2(props) {
    const [, setHeadingId] = _react.useContext.call(void 0, _AVNURAH2cjs.SelectHeadingContext) || [];
    const id = _3BSDKDKDcjs.useId.call(void 0, props.id);
    _3BSDKDKDcjs.useSafeLayoutEffect.call(void 0, () => {
      setHeadingId == null ? void 0 : setHeadingId(id);
      return () => setHeadingId == null ? void 0 : setHeadingId(void 0);
    }, [setHeadingId, id]);
    props = {
      ...props,
      id
    };
    props = _EXYNE2GEcjs.usePopoverHeading.call(void 0, props);
    return props;
  }
);
var SelectHeading = _PTOCUU2Dcjs.forwardRef.call(void 0, function SelectHeading2(props) {
  const htmlProps = useSelectHeading(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});



exports.SelectHeading = SelectHeading; exports.useSelectHeading = useSelectHeading;
